export default __webpack_public_path__ + "static/media/Default-Organization.aa015b06.svg";